import { ReactNode } from 'react';

import clsx from 'clsx';

export interface InputWrapperProps {
  children?: ReactNode;
  className?: string;
  isFocused?: boolean;
}

const InputWrapper = ({
  children,
  className,
  isFocused = false,
}: InputWrapperProps) => (
  <div
    className={clsx(
      'relative flex w-full justify-center rounded-[16px] font-bold transition-all duration-300 before:absolute before:inset-0 before:rounded-[16px] before:bg-input before:bg-size-300% before:transition-all before:duration-300 hover:bg-brand-primary-300 focus:bg-brand-primary-300 active:bg-brand-primary-300 motion-reduce:transition-none before:motion-reduce:transition-none',
      isFocused ? 'before:bg-right' : 'before:bg-left',
      className,
    )}
  >
    <div className="relative m-px w-full overflow-x-hidden rounded-[16px] bg-brand-white-100 transition-all duration-300 hover:bg-brand-primary-300 motion-reduce:transition-none">
      {children}
    </div>
  </div>
);

export default InputWrapper;
